import { createContext, useCallback, useContext, useMemo, useState } from 'react'

const Context = createContext<{ revision: number; markVerified: () => void } | null>(null)

/** Refresh signals only. The server remains the authority for broker visibility. */
export const CarrierVerificationProvider = ({ children }: { children: React.ReactNode }) => {
  const [revision, setRevision] = useState(0)
  const markVerified = useCallback(() => setRevision((value) => value + 1), [])
  const value = useMemo(() => ({ revision, markVerified }), [revision, markVerified])
  return <Context.Provider value={value}>{children}</Context.Provider>
}

export const useCarrierVerificationChange = () => useContext(Context)
